var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDimensions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "13px",
    viewBox: "0 0 23 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-dimensions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-1044.000000, -585.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-dimensions",
    transform: "translate(1044.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,12.5 L9.5,12.5 L10.606,10.289 C10.7755612,9.9506851 11.1215717,9.73706696 11.5,9.73706696 C11.8784283,9.73706696 12.2244388,9.9506851 12.394,10.289 L13.5,12.5 L20.5,12.5 C21.6045695,12.5 22.5,11.6045695 22.5,10.5 L22.5,2.5 C22.5,1.3954305 21.6045695,0.5 20.5,0.5 L2.5,0.5 C1.3954305,0.5 0.5,1.3954305 0.5,2.5 L0.5,10.5 C0.5,11.6045695 1.3954305,12.5 2.5,12.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 5.5,
    x2: 18.5,
    y2: 5.5,
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDimensions);
export default __webpack_public_path__ + "static/media/icon-dimensions.754556a1f6157255480c39084de83f84.svg";
export { ForwardRef as ReactComponent };